/* eslint-disable max-len */
import SharedStateBridge from '@sendible/shared-state-bridge';
import UserFeatureTagsModel from './models/user/UserFeatureTagsModel.js';

const FeatureTagsManagerView = Backbone.View.extend({
  initialize() {
    this.userFeatureTagsModel = new UserFeatureTagsModel();
  },

  setFeatureTagsFromServer(callback) {
    const timeoutId = setTimeout(() => {
      Backbone.trigger('featuretags::set-from-server');
    }, 3500);

    this.listenToOnce(
      this.userFeatureTagsModel,
      'sync',
      () => {
        this.processFeatureTags(this.userFeatureTagsModel.toJSON());

        if (callback) {
          callback();
        }

        clearTimeout(timeoutId);
      },
    );

    this.userFeatureTagsModel.fetch();
  },

  triggerFeatureTagUpdates(previousFeatureTags, newFeatureTags) {
    const featureTagsPastAndPresent = { ...previousFeatureTags, ...newFeatureTags };

    Object.keys(featureTagsPastAndPresent).forEach((key) => {
      const tagExistsInBoth = (
        previousFeatureTags[key]
        && newFeatureTags[key]
      );

      if (tagExistsInBoth) {
        const tagVersionsDifferent = (
          previousFeatureTags[key].version
        && newFeatureTags[key].version
        && (previousFeatureTags[key].version !== newFeatureTags[key].version)
        );

        if (tagVersionsDifferent) {
          Backbone.trigger(`${key}-feature-tag:updated`);
        }
      } else {
        Backbone.trigger(`${key}-feature-tag:updated`);
        SharedStateBridge.updateSpecificKey('user', 'featureTags', this.getAllFeatureTags());
        Backbone.trigger('render:top-navigation');
        Backbone.trigger('render:left_sidebar');
      }
    });
  },

  processFeatureTags(featureTags) {
    const previousFeatureTags = this.getAllFeatureTags();

    // sets the feature tag permissions
    this.setFeatureTags(featureTags.result);
    this.triggerFeatureTagUpdates(previousFeatureTags, this.getAllFeatureTags());

    Backbone.trigger('featuretags::set-from-server');
  },

  getAllFeatureTags() {
    const featureTags = localStorage.getItem('featureTags');

    /*
      For testing purposes
      var featureTags = '{"instagramOnboarding":{"version":"1.0.0"},"instagramBusinessManagement":{"version":"1.0.0"},"instagramReminderManagement":{"version":"1.0.0"},"composeview":{"version":"2.0.0"}}'
    */

    if (!featureTags) {
      return {};
    }

    return JSON.parse(featureTags);
  },

  setFeatureTags(tagsObject) {
    if (
      !tagsObject
      || _.isEmpty(tagsObject)
    ) {
      localStorage.removeItem('featureTags');
    } else {
      localStorage.setItem('featureTags', JSON.stringify(tagsObject));
    }
  },

  getFeatureTag(featureTagName) {
    const featureTags = this.getAllFeatureTags();

    if (featureTags) {
      return featureTags[featureTagName];
    }
    return null;
  },

  getVersionForFeature(featureTagName) {
    const tag = this.getFeatureTag(featureTagName);

    if (!tag) {
      return null;
    }

    return tag.version;
  },

  isFeatureTag(featureTagName) {
    const tag = this.getFeatureTag(featureTagName);
    return !!tag;
  },

});

export default FeatureTagsManagerView;
